<template>
  <div>
    <Baseloader v-if="loading" />
    <div
      v-if="grainesAsItems && grainesAsItems.length > 0 && !loading"
    >
      <div
        class="d-flex overflow-x"
      >
        <v-card
          v-for="(item, i) in grainesAsItems"
          :key="i"
          class="mx-1 cursor"
        >
          <v-hover v-slot="{ hover }">
            <v-img
              :src="photoGraine(item.codeGraine)"
              :height="$vuetify.breakpoint.mobile ? '96px' : '108px'"
              :width="$vuetify.breakpoint.mobile ? '128px' : '144px'"
              :gradient="isImageDownloaded ? '0deg,  black -30%, transparent 50%' : ''"
              cover
              :class="item.codeGraine === codeGraineSelected || hover ? 'border' : ''"
              @load="checkLoading"
              @click="change(item.codeGraine)"
            >
              <div
                v-if="item.codeGraine === codeGraineSelected"
                class="d-flex justify-end"
              >
                <v-btn
                  icon
                  small
                  class="white mr-2 mt-2"
                >
                  <v-icon
                    color="secondary"
                  >
                    mdi-check-circle
                  </v-icon>
                </v-btn>
              </div>
              <div class="titre-h4 ml-3 white--text position-detail">
                {{ item.text }}
              </div>
            </v-img>
          </v-hover>
        </v-card>
      </div>
    </div>
    <div
      v-if="grainesAsItems && grainesAsItems.length=== 0 && !loading"
      class="d-flex pt-3"
    >
      <BaseMessage
        type="info"
        text
        color="secondary"
        message="Aucune graine pour cette récolte"
      />
    </div>
  </div>
</template>

<script>
import capitalize from '@/filters/string.filter'
import { includes } from 'lodash'
import BaseMessage from '@/components/common/base-message.vue'
import Baseloader from '@/components/common/base-loader.vue'

export default {
  name: 'NavMenuGraine',
  components: {BaseMessage, Baseloader},
  props: {
    /**
     * Code graine de l'onglet sélectionné.
     */
    value: {
      type: String,
      default: null
    },
    /**
     * graines des différents onglets.
     */
    graines: {
      type: Array[Object],
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isImageDownloaded: false,
      codeGraineSelected: null,
      listePhotos: [
        { codeImage: 'AVOINE', listeCodesGraines: ['AV', 'AV2', 'AVB'] },
        { codeImage: 'BLE_DUR', listeCodesGraines: ['BD', 'BDB'] },
        { codeImage: 'BLE_TENDRE', listeCodesGraines: ['BA', 'BBI', 'BT', 'BT2', 'BTB'] },
        { codeImage: 'COLZA', listeCodesGraines: ['CO', 'CO2', 'COB', 'COE', 'COO'] },
        { codeImage: 'FEVEROLE', listeCodesGraines: ['FE', 'FE2', 'FEB'] },
        { codeImage: 'DEFAUT', listeCodesGraines: ['EP', 'GEB', 'PEB'] },
        { codeImage: 'LIN', listeCodesGraines: ['LI', 'LIJ'] },
        { codeImage: 'LUPIN', listeCodesGraines: ['LU'] },
        { codeImage: 'MAIS', listeCodesGraines: ['MAB', 'MA2', 'MAGR'] },
        { codeImage: 'DEFAUT', listeCodesGraines: ['MI', 'MIB'] },
        { codeImage: 'ORGE_FOURRAGERE', listeCodesGraines: ['OH', 'OFB', 'OF2', 'OHB', 'OPB', 'OPBB'] },
        { codeImage: 'POIS', listeCodesGraines: ['PO', 'POB', 'PO2', 'PC', 'PC2', 'PCB'] },
        { codeImage: 'SEIGLE', listeCodesGraines: ['SE', 'SE2', 'SEB'] },
        { codeImage: 'SARRASIN', listeCodesGraines: ['SA', 'SA2', 'SAB'] },
        { codeImage: 'SOJA', listeCodesGraines: ['SO', 'SOB'] },
        { codeImage: 'SORGHO', listeCodesGraines: ['SOR', 'SGB'] },
        { codeImage: 'TOURNESOL', listeCodesGraines: ['TO', 'TOB', 'TOO', 'TOOB', 'TOOI'] },
        { codeImage: 'TRITICALE', listeCodesGraines: ['TR', 'TR2', 'TRB'] }
      ]
    }
  },

  computed: {
    grainesAsItems () {
      return this.graines.map(graine => {
        return {
          codeGraine: graine.code,
          text: capitalize.capitalize(graine.libelle)
        }
      })
    }
  },
  watch: {
    value () {
      if (this.value != null && this.graines.findIndex(g => g.code === this.value) > -1) {
        this.codeGraineSelected = this.value
      }
      else if (this.grainesAsItems.length) {
        this.codeGraineSelected = this.grainesAsItems[0].codeGraine
      } else {
        this.codeGraineSelected = null
      }
    }
  },
  created () {
    if (this.value != null && this.graines.findIndex(g => g.code === this.value) > -1) {
        this.codeGraineSelected = this.value
      }
      else if (this.grainesAsItems.length) {
        this.codeGraineSelected = this.grainesAsItems[0].codeGraine
      } else {
        this.codeGraineSelected = null
      }
  },
  methods: {
    photoGraine (codeGraine) {
      let result = '/images/photos-graines/DEFAUT.jpg'
      this.listePhotos.forEach(g => {
        if (includes(g.listeCodesGraines, codeGraine)) {
          result = '/images/photos-graines/' + g.codeImage + '.jpg'
        }
      })
      return result

    },
    change (codeGraine) {
      if (codeGraine != null && this.graines.findIndex(g => g.code === codeGraine) > -1) {
        this.codeGraineSelected = codeGraine
      } else if (this.grainesAsItems.length) {
        this.codeGraineSelected = this.grainesAsItems[0].codeGraine
      } else {
        this.codeGraineSelected = null
      }
      this.$emit('change', this.codeGraineSelected)
    },
    checkLoading () {
      this.isImageDownloaded = true
    }
  }
}
</script>

<style lang="scss" scoped>
.position-detail {
  position: absolute;
  bottom: 5px;
}
.v-btn--icon.v-size--small {
    height: 19px;
    width: 19px;
}
.border {
  border: 3px solid var(--v-secondary-base);
}
.cursor {
  cursor: pointer;
}
.overflow-x {
  overflow-x: auto;
}

</style>
